import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useSite } from "@/lib/site";
import { Reveal } from "@/components/Reveal";
import SectionHead from "@/components/SectionHead";
import PostCard from "@/components/PostCard";

export default function LatestNews() {
  const { t } = useLang();
  const site = useSite();
  const posts = (site?.posts || []).slice(0, 3);
  if (!posts.length) return null;

  return (
    <section data-testid="home-latest-news" className="mx-auto max-w-7xl px-5 sm:px-8 pb-24 md:pb-32">
      <SectionHead eyebrow={t("news_latest_eyebrow")} title={t("news_latest_title")} sub={t("news_sub")} />
      <div className="grid gap-7 md:grid-cols-3">
        {posts.map((p, i) => (
          <Reveal key={p.id} delay={0.06 * i}>
            <PostCard post={p} />
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-10">
        <Link to="/news" data-testid="home-news-view-all" className="btn-outline">
          {t("news_view_all")} <ArrowRight className="h-4 w-4 rtl:rotate-180" />
        </Link>
      </Reveal>
    </section>
  );
}
